import { useState } from 'react';

const faqItems = [
  {
    q: '吃瓜入口是什么？',
    a: '吃瓜入口是一个专注于每日大赛资讯聚合的平台，汇集选秀综艺、电竞赛事、音乐比赛、舞蹈竞技等各类大赛的最新视频、独家爆料与系列追踪内容。入口每日更新，让你一站式获取全网大赛吃瓜内容，不再错过任何精彩。',
  },
  {
    q: '每日大赛最新视频在哪里看？',
    a: '在视频精选板块可以找到每日大赛最新视频内容，我们整理了来自各大赛事的最新舞台、比赛回放和独家花絮。所有视频内容均已标注时长和观看量，点击即可在线观看。你也可以通过话题热榜找到相关视频入口。',
  },
  {
    q: '大赛吃瓜在线内容多久更新一次？',
    a: '吃瓜入口保持每日高频更新，每日快讯实时追踪大赛动态，新内容上线后首页同步刷新。热门赛事期间更新频率更高，重大爆料和独家内容会优先推送至焦点专题区，确保你始终获取最新信息。',
  },
  {
    q: '如何向吃瓜入口投稿或爆料？',
    a: '欢迎通过爆料投稿板块联系我们，支持微信公众号、邮件和微博私信三种方式。投稿内容一经采用将注明来源并严格保护投稿人隐私。我们尤其欢迎独家现场素材、选手一手信息和赛事内幕爆料。',
  },
  {
    q: '吃瓜入口的内容来源可靠吗？',
    a: '所有大赛吃瓜内容均经过多方交叉核实，重要信息会标注来源并附可信度评估。我们拒绝传播无根据的谣言和虚假爆料，致力于为吃瓜群众提供可靠、有据可查的大赛娱乐资讯。如发现内容有误，欢迎通过爆料投稿渠道反馈。',
  },
];

export default function SectionFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          常见问题
        </h2>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 cursor-pointer text-left"
              >
                <h3 className="font-heading text-base md:text-lg text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-xl text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-[500px] pb-5 md:pb-6 px-5 md:px-6' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}